// Dependencies
import React, { Component } from "react";

// Components & Containers
import "./style.css";

export default class NotFound extends Component {
  render() {
    return (
      <div>
        <p>404 - Not Found</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotFound/index.jsx